import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from '../../data/seo';

/**
 * Google Analytics 4 page-view tracking for client-side navigation.
 *
 * The gtag snippet in public/index.html loads GA and logs the initial
 * page_view for the landing URL. Because this is an SPA, subsequent route
 * changes don't reload the page, so we send those page_views manually here.
 * The first effect run is skipped to avoid double-counting the landing view.
 */
export default function Analytics() {
  const { pathname, search } = useLocation();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: resolveSeo(pathname).title,
    });
  }, [pathname, search]);

  return null;
}
